export const COOKIES_INIT = 'waitrose/cookies/INIT' as const;
export const COOKIES_ACCEPT_ALL = 'waitrose/cookies/COOKIES_ACCEPT_ALL' as const;
export const COOKIES_REJECT_ALL = 'waitrose/cookies/COOKIES_REJECT_ALL' as const;
export const COOKIES_VIEW_PREFERENCES = 'waitrose/cookies/COOKIES_VIEW_PREFERENCES' as const;
export const COOKIES_UPDATE_PREFERENCES = 'waitrose/cookies/COOKIES_UPDATE_PREFERENCES' as const;
export const COOKIES_FORCE_SHOW_CONTROLS = 'waitrose/cookies/FORCE_SHOW_CONTROLS' as const;
export const COOKIES_MONETATE = 'waitrose/cookies/MONETATE' as const;
